import { render, staticRenderFns } from "./NotificationManage.vue?vue&type=template&id=12fb5f8c&scoped=true&"
import script from "./NotificationManage.vue?vue&type=script&lang=js&"
export * from "./NotificationManage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationManage.vue?vue&type=style&index=0&id=12fb5f8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb5f8c",
  null
  
)

export default component.exports